// extracted by mini-css-extract-plugin
export default {"howToUse":"BreedsList_howToUse__sXBfz","listContainer":"BreedsList_listContainer__UnDsP","list":"BreedsList_list__e-zEh","breedsList":"BreedsList_breedsList__VXnSc"};